<app-activity-calendar-filter></app-activity-calendar-filter>

<full-calendar #ppfc [options]="options"></full-calendar>

<p-overlayPanel #eventHintOP styleClass="overlay-panel event-panel">
  <ng-container *ngIf="activityInHint">
    <app-event-tip [activityInHint]="activityInHint"></app-event-tip>
  </ng-container>
</p-overlayPanel>
<!--<span class="calendar-title">{{calendarTitle}}</span>-->


<div class="loading-screen" *ngIf="loadingCalendar" >
  <!--<div class="loading-screen">-->
  <lib-progress-spinner></lib-progress-spinner>
</div>

